@import "icons.css";

@font-face {
  font-family: itc-benguiat-condensed-bold;
  src: url("vendor/itc-benguiat-condensed-bold.otf") format("opentype");
}

:root {
  --font-color-1: #231c14;
  --font-color-2: #e0d1c1;
  --font-color-3: #d4d4d4;
  --font-color-4: #87ceeb;
  --background-color-1: #f6f2ea;
  --background-color-2: #120e0a;
  --border-color-1: rgba(232, 221, 209, 0.15);
  --white: #fff;
  --black: #000;
}

[data-theme="dark"] {
  --font-color-1: #e0d1c1;
  --font-color-2: #231c14;
  --font-color-3: #120e0a;
  --font-color-4: #2c4daa;
  --background-color-1: #120e0a;
  --background-color-2: #e0d1c1;
  --border-color-1: rgba(35, 28, 20, 0.25);
  --white: #000;
  --black: #fff;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

a {
  color: inherit;
}

body {
  font-family: "Open Sans", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  color: var(--font-color-1);
  min-height: 100vh;
  padding: 20px;
  background-image: var(--background-img);
  background-color: var(--background-color-1);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

html[data-layout="full"] .container {
  max-width: 100%;
}

header {
  padding: 20px;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

h1 {
  font-family: itc-benguiat-condensed-bold;
  color: var(--font-color-1);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  margin-bottom: 10px;
}

h2 {
  font-size: unset;
  margin-bottom: unset;
  font-weight: 600;
  line-height: unset;
}

.subtitle {
  font-size: 1.1em;
}

.options-wrapper {
  padding: 6px 24px;
  display: flex;
  flex-direction: row-reverse;
  margin-top: -40px;
  font-size: 1.3em;
  gap: 8px;
}

.options-wrapper .btn {
  color: var(--font-color-1);
}

.search-wrapper {
  display: flex;
  justify-content: center;
  padding: 6px;
}

.search-input {
  border-radius: 999px;
  padding: 25px 22px;
  font-size: 1.25rem;
  box-shadow: inset 0 -1px 1 rgb(from var(--white) r g b / 15%);
  border: 1px solid var(--border-color-1);
  background: var(--background-color-2);
  color: var(--font-color-2);
}

.search-input:focus {
  outline: none;
  box-shadow: 0 0px 20px rgb(from var(--black) r g b / 15%);
  border-color: var(--border-color-1);
  background: var(--background-color-2);
  color: var(--font-color-2);
}

input.search-input::placeholder {
  color: var(--font-color-2);
}

#filter-wrapper {
  padding: 6px 12px;
  pointer-events: auto;
}

#filter-wrapper .filter-group {
  display: inline-block;
}

.bootstrap-select.dropdown {
  width: auto !important;
}

.bootstrap-select .selectpicker {
  pointer-events: none;
}

.bootstrap-select .dropdown-toggle {
  min-height: 42px;
  padding: 6px 10px;
  border-radius: 12px;
  background: none;
  border: none;
  color: inherit;
  display: flex;
  align-items: center;
  gap: 8px;
}

.bootstrap-select .btn.btn-cr:focus {
  outline: none !important;
  box-shadow: none;
}

.bootstrap-select > .dropdown-toggle.bs-placeholder {
  color: inherit;
}

.bootstrap-select .filter-option-inner-inner.filter-pill-holder,
.bootstrap-select .filter-option-inner-inner {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
  white-space: nowrap;
  vertical-align: middle;
}

.filter-pill {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 0.85rem;
  line-height: 1;
  white-space: nowrap;
}

.filter-pill-holder .filter-pill {
  cursor: pointer;
  user-select: none;
}

html:not([data-theme="dark"]) .filter-pill:not(.light) {
  border-color: transparent;
  background: var(--color);
  color: hsl(from var(--color) h s 95);
}

.filter-pill.solid {
  border-color: transparent !important;
  background: var(--color) !important;
  color: hsl(from var(--color) h s 95) !important;
}

html[data-theme="dark"] .filter-pill.light {
  border-color: hsl(from var(--color) h s l / 100%) !important;
  background: transparent !important;
  color: hsl(from var(--color) h s 35) !important;
}

.filter-pill.disabled {
  --color: hsla(30, 3%, 51%, 1);
  background: hsl(from var(--color) h s l / 12%);
  color: hsl(from var(--color) h s l);
  border: 1px solid hsl(from var(--color) h s l / 15%);

  pointer-events: none;
}

.filter-pill.series {
  --color: hsl(0, 37%, 45%);
  background: hsl(from var(--color) h s l / 12%);
  color: hsl(from var(--color) h calc(s + 25) calc(l + 30));
  border: 1px solid hsl(from var(--color) h s l / 15%);
}

.filter-pill.episode {
  --color: hsla(220, 36%, 45%, 1);
  background: hsl(from var(--color) h s l / 12%);
  color: hsl(from var(--color) h calc(s + 25) calc(l + 30));
  border: 1px solid hsl(from var(--color) h s l / 15%);
}

.filter-pill.tag {
  --color: hsla(270, 37%, 45%, 1);
  background: hsl(from var(--color) h s l / 12%);
  color: hsl(from var(--color) h calc(s + 25) calc(l + 30));
  border: 1px solid hsl(from var(--color) h s l / 15%);
}

.filter-pill.mini {
  padding: 4px 6px;
  font-size: 0.75rem;
  font-weight: normal;
}

.filter-pill-holder .filter-pill:hover {
  background: rgba(255, 103, 103, 0.09);
  color: rgba(255, 134, 134, 1);
  border: 1px solid rgba(255, 103, 103, 0.12);
}

.stats {
  text-align: center;
  margin-bottom: 20px;
  font-size: 0.95em;
}

.error {
  background: rgba(220, 53, 69, 0.2);
  border: 1px solid rgba(220, 53, 69, 0.5);
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  color: rgba(255, 107, 107, 1);
}

.loading {
  text-align: center;
  padding: 60px 20px;
  color: var(--font-color-2);
  font-size: 1.2em;
}

.results {
  display: grid;
  column-gap: 20px;
}

html:not([data-layout="full"]) .results#key-results {
  grid-template-columns: repeat(auto-fit, minmax(min(425px, 100%), 1fr));
}

html:not([data-layout="full"]) .results#related-results {
  grid-template-columns: repeat(auto-fit, minmax(min(375px, 100%), 1fr));
}

.entry-card {
  display: grid;
  grid-template-rows: subgrid;
  grid-row-end: span 4;
  margin-bottom: 20px;

  background: var(--background-color-2);
  color: var(--font-color-3);
  border: 1px solid var(--border-color-1);
  border-radius: 12px;
  padding: 25px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.02);
}

.entry-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(212, 175, 55, 0.2);
}

.entry-header {
  display: flex;
  word-wrap: anywhere;
  gap: 8px;
  margin-bottom: 15px;
  align-items: baseline;

  font-size: 1.5em;
  color: var(--font-color-2);
}

.entry-title {
  display: flex;
  word-wrap: break-word;
  gap: 8px;
  flex-wrap: wrap;
  flex-grow: 1;
}

.entry-name {
  position: relative;
}

.entry-share {
  font-size: 0.55em;
  height: 100%;
  align-content: center;
}

.entry-aliases {
  flex-grow: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  font-size: 0.6em;
  color: var(--font-color-3);
  font-style: italic;
}

.entry-aliases .entry-alias:not(:last-child) {
  margin-right: 8px;
}

.entry-alias {
  flex-shrink: 0;
}

.entry-links {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.entry-depictions {
  word-wrap: break-word;
}

.entry-depictions .entry-depiction-latest {
  cursor: initial !important;
  text-align: inherit;
  padding: 0;
  color: currentColor;
  margin-bottom: 15px;
  box-shadow: none !important;
}

.entry-depictions .entry-depiction-old {
  padding: 16px;
  max-height: 300px;
  grid-template-columns: repeat(auto-fit, minmax(min(325px, 100%), 1fr));
  grid-template-rows: min-content;
  gap: 8px;
  overflow-y: auto;
  margin: 0;
  margin-bottom: 8px;

  align-content: baseline;
  border: 2px solid var(--border-color-1);
  border-radius: 8px;
  border-style: dashed;
}

.entry-depictions .entry-depiction-old.show {
  display: grid;
}

.entry-depictions .entry-depiction-old:empty {
  display: none;
}

.entry-depictions .entry-depiction-old span:first-child {
  margin-right: 8px;
}

.entry-connections {
  padding: 16px;
  max-height: 300px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(325px, 100%), 1fr));
  grid-template-rows: min-content;
  gap: 8px;
  overflow-y: auto;
  align-content: baseline;
  margin: 0;

  border: 2px solid var(--border-color-1);
  border-radius: 8px;
}

.entry-connections:empty {
  display: none;
}

.entry-depictions:empty + .entry-connections {
  grid-row-start: 2;
  grid-row-end: span 2;
}

.entry-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 15px;
  align-items: baseline;
}

.no-results {
  text-align: center;
  padding: 60px 20px;
  color: var(--font-color-1);
  font-size: 1.2em;
}

.hidden-input {
  position: absolute !important;
  z-index: 0 !important;
  width: 0 !important;
  height: 0 !important;
  left: 0 !important;
  top: 0 !important;
  pointer-events: none !important;
  opacity: 0 !important;
  border: none;
}

.before {
  position: absolute;
  transform: translateX(-120%);
}

@media (hover: hover) {
  .hover-container:not(:hover) .on-hover {
    display: none;
  }
}

.mark,
mark {
  border-bottom: 1px solid var(--white);
  background: none;
  color: var(--white);
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  h1 {
    font-size: 4rem;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  h1 {
    font-size: 5rem;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  h1 {
    font-size: 7rem;
  }
}
